import { TOGGLE_SIZES } from 'ui/toggle';
import { StyledToggle, StyledButtonWithToggle } from './Styled';

export interface ButtonWithToggleTypes {
  /** Is the button Toggled */
  isToggleActive?: boolean;
  /** The click handler for the button */
  onClick?: (e: React.MouseEvent) => void;
  children?: React.ReactNode;
}

export const ButtonWithToggle = ({ isToggleActive, onClick, children }: ButtonWithToggleTypes) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <StyledButtonWithToggle onClick={handleClick} isToggleActive={isToggleActive}>
      {children}
      <StyledToggle
        id="IntervalMetricToggle"
        name="IntervalMetricToggle"
        isActive={isToggleActive}
        onClick={() => {
          return null;
        }}
        size={TOGGLE_SIZES.SMALL}
      />
    </StyledButtonWithToggle>
  );
};
